export function setOrganizationAudienceRules(state, rules = {}) {
  const {
    affiliationTypes = [],
    branches = [],
    subgroups = [],
  } = rules;
  state.audience_rules = {
    memberStatus: state.default.audience_rules.memberStatus,
    affiliationTypes,
    branches,
    subgroups,
  };
}
